export default "__VITE_ASSET__Sbwcs6lu__"